import styled from 'styled-components'
import Clear from '@material-ui/icons/Clear'
import HelpIcon from '@material-ui/icons/Help'
import RedIcon from '@material-ui/icons/Cancel'
import GreenIcon from '@material-ui/icons/CheckCircle'
import { colors } from '../../../theme/Global'

export const PosterCheckToolTipModalList = styled.ul`
  text-align: left;
  list-style-type: none;
  margin: 0;
  padding: 0;
  li p {
    display: inline-block;
    position: relative;
    bottom: 5px
  }
`

export const PosterCheckModalHelpIcon = styled(HelpIcon)`
  display: inline-block;
  color: ${colors.mediumGrey};
  height: 1rem;
  width: 1rem;
  margin-left: 0.10rem;
  line-height: inherit;
`

export const DarkRedCancelIcon = styled(RedIcon)`
  display: inline-block;
  color: ${colors.govDocsRed};
  padding-right: 1rem;
`

export const GreenCheckCircleIcon = styled(GreenIcon)`
  display: inline-block;
  color: ${colors.green};
  padding-right: 1rem;
`

export const ModalCloseButton = styled(Clear)`
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
  margin: 1rem;
`
